import Icon from "@ant-design/icons";

const BackButtonCircleIconSVG = (props) => (
  <svg
    width={props?.width || "25em"}
    height={props?.width || "25em"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.26 15.53L9.73999 12L13.26 8.46997"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const BackButtonCircleIcon = (props) => (
  <Icon component={BackButtonCircleIconSVG} {...props} />
);

export default BackButtonCircleIcon;
